import { ImageName } from "@mcleod/images";
import { Button, Dialog, Layout, Panel } from "@mcleod/components";
import { DispatchSelectTrailer } from "./DispatchSelectTrailer";
import { HorizontalAlignment, ModelRow } from "@mcleod/core";

export class SelectTrailerDialog extends Dialog {

    private previous: any;
    private current: any;

    private layout: DispatchSelectTrailer;
    private acceptButton: Button;
    private cancelButton: Button;

    private _selectedTrailer: string = null;

    constructor(previous: any, current: any) {
        super({
            title: "Trailer Missing",
            okVisible: false,
            panelTitleProps: {backgroundColor: "primary.darker", color: "primary.reverse"}
        });
        this.previous = previous;
        this.current = current;
    }

    private getModelRow(): ModelRow {
        return new ModelRow(null, false, {
            "curr_location_id": this.current.location_id,
            "curr_location_name": this.current.location_name,
            "curr_location_address": this.current.address,
            "curr_location_address2": this.current.address2,
            "curr_city": this.current.city_name,
            "curr_state": this.current.state,
            "curr_zip_code": this.current.zip_code,
            "prev_location_id": this.previous?.location_id,
            "prev_location_name": this.previous?.location_name,
            "prev_location_address": this.previous?.address,
            "prev_location_address2": this.previous?.address2,
            "prev_city": this.previous?.city_name,
            "prev_state": this.previous?.state,
            "prev_zip_code": this.previous?.zip_code,
        });

    }

    private createAcceptButton(): Button {
        return new Button({
            caption: "Accept Trailer",
            color: "primary.reverse",
            backgroundColor: "primary",
            imageName: ImageName.check,
            default: true,
            enabled: false,
            disabledTooltip: "Select a trailer to continue."
        });
    }

    private createCancelButton(): Button {
        const cancelButton = new Button({
            caption: "Cancel",
            imageName: ImageName.x,
            rowBreak: false,
            marginRight: 48
        });
        cancelButton.addClickListener(() => this.close(false));
        return cancelButton;
    }

    private createButtonsPanel(): Panel {
        const buttonsPanel = new Panel({
            fillRow: true,
            align: HorizontalAlignment.CENTER,
            marginTop: 24
        });

        // Cancel
        this.cancelButton = this.createCancelButton();
        buttonsPanel.add(this.cancelButton);

        // Accept
        this.acceptButton.addClickListener(() => {
            if (this.validateSimple()) this.close(true);
        });
        buttonsPanel.add(this.acceptButton);

        return buttonsPanel;
    }


    override async show(): Promise<any> {
        this.layout = Layout.getLayout("lme/dispatch/asset/DispatchSelectTrailer") as DispatchSelectTrailer;
        this.layout.addLayoutLoadListener(() => this.layout.initialize(this.getModelRow()));

        this.acceptButton = this.createAcceptButton();

        this.layout.addTrailerSelectListener((newValue: string) => {
            this._selectedTrailer = newValue;
            this.acceptButton.enabled = newValue != null;
        });

        this.add(this.layout);
        this.add(this.createButtonsPanel());
        return super.show();
    }

    override close(promiseResult?: any) {
        return super.close(promiseResult ? this._selectedTrailer : null);
    }
}
